import { useState, useEffect } from "react";
import { toast } from "sonner";
import {
  isWebSerialSupported,
  requestSerialPrinter,
  reconnectSerialPrinter,
  disconnectSerialPrinter,
  printTestPageSerial,
} from "@/utils/webSerialPrintService";

export function useSerialPrinter() {
  const [serialSupported] = useState(isWebSerialSupported());
  const [serialPrinter, setSerialPrinter] = useState(null);
  const [serialConnecting, setSerialConnecting] = useState(false);
  const [serialTestPrinting, setSerialTestPrinting] = useState(false);

  useEffect(() => {
    if (serialSupported) {
      reconnectSerialPrinter().then((info) => {
        if (info) setSerialPrinter(info);
      });
    }
  }, [serialSupported]);

  const handleConnectSerial = async () => {
    setSerialConnecting(true);
    try {
      const info = await requestSerialPrinter();
      setSerialPrinter(info);
      toast.success("Impressora conectada via porta serial!");
    } catch (err) {
      toast.error(err.message);
    }
    setSerialConnecting(false);
  };

  const handleDisconnectSerial = async () => {
    await disconnectSerialPrinter();
    setSerialPrinter(null);
    toast.info("Impressora serial desconectada");
  };

  const handleTestSerial = async () => {
    setSerialTestPrinting(true);
    try {
      await printTestPageSerial();
      toast.success("Pagina de teste impressa com sucesso!");
    } catch (err) {
      toast.error("Erro: " + err.message);
    }
    setSerialTestPrinting(false);
  };

  return {
    serialSupported,
    serialPrinter,
    serialConnecting,
    serialTestPrinting,
    handleConnectSerial,
    handleDisconnectSerial,
    handleTestSerial,
  };
}
